import { Slider } from '@mui/material';

import { withStyles } from 'tss-react/mui';

export const ImageCropperSlider = withStyles(Slider, theme => ({
  root: {
    height: 4,
  },
  thumb: {
    border: '1px solid #aaa',
    background: '#fff',
  },
  rail: {
    height: 4,
    color: theme.palette.grey[400],
  },
  track: {
    height: 4,
    color: theme.palette.secondary.main,
  }
}));
